
import {Component, Prop} from 'vue-property-decorator'
import BaseForm from '@/components/forms/BaseForm'
import BaseFormContainer from '@/containers/base/BaseFormContainer.vue'
import {required} from 'vuelidate/lib/validators'
import GroupeModel from '@/models/GroupeModel'
import convertDateDirective from '@/directives/convertDateDirective'
import {isCoprolibDate} from '@/helpers/validators'

@Component({
  components: {
    BaseFormContainer
  },
  validations: {
    form: {
      NOM: {
        required
      }
    }
  }
})
export default class GroupeForm extends BaseForm {
  model = GroupeModel
}
